import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import Title from "../../components/Title/Title";
import '../../styles/Source-Link.css';
import CustomButton from "../../components/Custom-Button/CustomButton";
export default function HeartJesus() {

    return (
        <div>
            <NavBar/>
            <Title text={"Devoção ao Sagrado Coração de Jesus"}/>

            <p className="info-text">
            A devoção ao Sagrado Coração de Jesus tem raízes bíblicas (o lado aberto de Cristo na cruz, Jo 19,34-37) e amadureceu na Igreja medieval (místicos como Santa Gertrudes e Santa Matilde de Magdeburgo). <br/>
            Tornou-se devoção popular sobretudo no século XVII, com São João Eudes celebrando a primeira festa litúrgica em 1672 e, especialmente, através das revelações de Santa Margarida Maria Alacoque em Paray-le-Monial (1673-1675). <br/>
            Nelas, Jesus mostrou seu Coração flamejante de amor, pedindo comunhões reparadoras nas primeiras sextas-feiras e a instituição de sua festa. <br/>
            Essas práticas foram formalmente apoiadas pelo Papa Pio IX (que em 1856 tornou obrigatória a festa do Sagrado Coração). <br/>
            Ao longo do século XX, papas como Leão XIII, Pio XI e Pio XII confirmaram e expandiram o culto ao Sagrado Coração. <br/>
            Em 2024, o Papa Francisco publicou a encíclica Dilexit Nos destacando a centralidade do Coração de Cristo na fé cristã.
            </p> 

            <Title text={"Fundamentação Teológica"}/>
            <p className="info-text">O Magistério ensina que o Coração de Jesus simboliza o centro do amor redentor de Cristo pela humanidade. <br/>
            O Catecismo afirma que “a oração da Igreja venera e honra o Coração de Jesus” como representação do Verbo encarnado que se deixou trespassar por amor aos homens. <br/>
            Pio XI chamou a devoção “compêndio de toda a religião” porque leva as almas a conhecer e amar mais profundamente a Cristo. <br/>
            Em Dilexit nos, o Papa Francisco ensina que o Coração de Cristo é “fornalha ardente de amor divino e humano” e “centro pessoal de onde brota o seu amor”. <br/>
            Assim, a espiritualidade do Sagrado Coração enfatiza a misericórdia, a ternura e a renovação interior do crente.
            </p>
            
            <Title text={"Práticas Devocionais"}/>
            <p className="info-text">Destacam-se a festa litúrgica do Sagrado Coração, sempre na sexta-feira após o sábado da Santíssima Trindade (normalmente junho), e a comunhão reparadora nas primeiras sextas-feiras do mês (recomendada por Cristo a Santa Margarida Maria). <br/>
            Práticas populares incluem a Hora Santa de adoração (oração de uma hora diante do Santíssimo), consagrações e entronizações do Sagrado Coração em famílias e instituições. <br/>
            O Apostolado da Oração (Rede Mundial de Oração do Papa) promove orações ao Coração de Jesus, inclusive intenções mensais do Santo Padre. <br/>
            O texto litúrgico da festa salienta que o Sagrado Coração é “fonte de onde brotam todas as palavras e ações de Cristo”, e a liturgia convida à adoração do Coração transpassado (Via-Sacra). <br/>
            Entre as promessas atribuídas a Santa Margarida Maria, Jesus assegurou grandes graças a quem honrar seu Coração, embora elas pertençam à piedade privada e não imponham obrigação de fé.
            </p>

            <div className="btn-row">
            <CustomButton route={"/Sagrados-Coracoes"} text={"Voltar"}/>
            </div>
   
            <Footer/>
        </div>
    )
}